"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/objectDestructuringEmpty"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _services = require("@alycecom/services");

var _ui = require("@alycecom/ui");

var _utils = require("@alycecom/utils");

var _useTrackCompliance = require("../hooks/useTrackCompliance");

var _SelectCampaign = require("../GiftingFlow/modules/SelectCampaign");

var _features = require("../Shared/store/features");

var _FlowWrapper = _interopRequireDefault(require("./components/FlowWrapper/FlowWrapper"));

var _CreateGiftModule = require("./CreateGiftModule.hook");

var _useTrackGiftingFlow = require("./hooks/useTrackGiftingFlow");

var _user = require("./shapes/user.shape");

var _recipient = require("./store/recipient/recipient.actions");

/**
 * @param {Object} props
 * @param {number} [props.contactId=null] -
 * Id of contact for that where gift will be assigned
 * @param {string} [props.sfContactId=null] -
 * Salesforce contact id
 * @param {string} [props.sfLeadId=null] -
 * Salesforce lead id
 * @param {function(id: number): void} props.onCreate -
 * Callback that called when gift has been created.
 * @param {number} [defaultCampaignId=null] -
 * If props has been passed the step where user need to choose campaign will be skipped,
 * and created gift will assigned to that campaign id.
 * @param {number[]} [availableCountryIds=undefined]
 * @param {{
 *   orgName: string,
 *   orgId: number,
 * }} user
 * @param {object} [props.settings={ apiHost: string }]
 * @param {function (): void} props.onClose
 *
 * @example
 * const contactId = 101;
 * const onCreate = useCallback(giftId => console.log(`gift ${giftId} has been created`), []);
 * const campaignId = 1812;
 * return (
 *  <CreateGiftModule
 *    contactId={contactId}
 *    onCreate={onCreate}
 *    defaultCampaignId={campaignId}
 *    settings={{ apiHost: window.APP_CONFIG.apiHost }}
 *  />
 * );
 *
 * @returns {React.Element}
 */
var CreateGiftModule = function CreateGiftModule(_ref) {
  var contactId = _ref.contactId,
      sfLeadId = _ref.sfLeadId,
      sfContactId = _ref.sfContactId,
      onCreate = _ref.onCreate,
      defaultCampaignId = _ref.defaultCampaignId,
      availableCountryIds = _ref.availableCountryIds,
      user = _ref.user,
      onClose = _ref.onClose;
  (0, _objectDestructuringEmpty2.default)(_ref.settings);
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isComplianceOpen = _useState2[0],
      setIsComplianceOpen = _useState2[1];

  var trackComplianceSubmitted = (0, _useTrackCompliance.useTrackComplianceSubmitted)(user);
  var trackComplianceLinkVisited = (0, _useTrackCompliance.useTrackComplianceLinkVisited)(user);

  var _useCreateGiftModule = (0, _CreateGiftModule.useCreateGiftModule)({
    recipientId: contactId,
    sfLeadId,
    sfContactId,
    campaignId: parseInt(defaultCampaignId, 10)
  }),
      campaignId = _useCreateGiftModule.campaignId,
      setCampaignId = _useCreateGiftModule.setCampaignId,
      createGift = _useCreateGiftModule.createGift,
      teamSettings = _useCreateGiftModule.teamSettings,
      useOnCreate = _useCreateGiftModule.useOnCreate;

  var trackChosenCampaign = (0, _useTrackGiftingFlow.useTrackChosenCampaign)(user);
  var trackContactSubmit = (0, _useTrackGiftingFlow.useTrackContactOneOffSubmit)(user);
  useOnCreate(onCreate);
  var hasBudgetManagementLimit = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.BUDGET_MANAGEMENT_LIMIT));
  var hasBudgetManagementSetup = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.BUDGET_MANAGEMENT_SETUP));
  var hasBudgetFeaturesEnabled = hasBudgetManagementLimit && hasBudgetManagementSetup;
  (0, _react.useEffect)(function () {
    if (defaultCampaignId) {
      setCampaignId(defaultCampaignId);
    }
  }, [defaultCampaignId, setCampaignId]);
  var handleCreateGift = (0, _react.useCallback)(function () {
    createGift();
    return function () {
      return dispatch((0, _recipient.giftCreateRecipientReset)());
    };
  }, [createGift, dispatch]);
  (0, _react.useEffect)(function () {
    if (!campaignId) return;

    if (teamSettings.complianceIsRequired) {
      setIsComplianceOpen(true);
    } else {
      handleCreateGift();
    }
  }, [campaignId, teamSettings, handleCreateGift, createGift]);
  var onSetCampaign = (0, _react.useCallback)(function (campaign) {
    setCampaignId(campaign.id);
    trackContactSubmit(campaign.research_flow);
    trackChosenCampaign();
  }, [setCampaignId, trackChosenCampaign, trackContactSubmit]);
  var handleFinishCompliance = (0, _react.useCallback)(function (isSuccessful) {
    trackComplianceSubmitted(isSuccessful);

    if (isSuccessful) {
      handleCreateGift();
    } else {
      onClose();
    }

    setIsComplianceOpen(false);
  }, [handleCreateGift, onClose, trackComplianceSubmitted]);
  var multisort = (0, _react.useMemo)(function () {
    return [{
      field: 'isFavourite',
      direction: _utils.SortDirection.desc
    }, hasBudgetFeaturesEnabled ? {
      field: 'insufficientBudget',
      direction: _utils.SortDirection.asc
    } : {
      field: 'giftsLimit',
      direction: _utils.SortDirection.desc
    }, {
      field: 'name',
      direction: _utils.SortDirection.asc
    }];
  }, [hasBudgetFeaturesEnabled]);
  return /*#__PURE__*/_react.default.createElement(_FlowWrapper.default, {
    container: true,
    direction: "column",
    wrap: "nowrap"
  }, /*#__PURE__*/_react.default.createElement(_ui.CompliancePopup, {
    width: 600,
    isOpen: isComplianceOpen,
    onFinish: handleFinishCompliance,
    promptText: teamSettings.compliancePromptText || '',
    revertText: teamSettings.complianceRevertText,
    onLinkVisited: trackComplianceLinkVisited,
    link: teamSettings.complianceLink
  }), /*#__PURE__*/_react.default.createElement(_SelectCampaign.SelectCampaign, {
    availableCountryIds: availableCountryIds,
    filters: {
      types: [_services.CampaignType.One2One],
      multisort
    },
    onSelect: onSetCampaign
  }));
};

CreateGiftModule.propTypes = {
  contactId: _propTypes.default.number,
  sfContactId: _propTypes.default.string,
  sfLeadId: _propTypes.default.string,
  defaultCampaignId: _propTypes.default.number,
  availableCountryIds: _propTypes.default.arrayOf(_propTypes.default.number),
  onCreate: _propTypes.default.func.isRequired,
  user: _user.User.isRequired,
  onClose: _propTypes.default.func,
  settings: _propTypes.default.shape({
    apiHost: _propTypes.default.string
  }).isRequired
};
CreateGiftModule.defaultProps = {
  contactId: null,
  sfContactId: null,
  sfLeadId: null,
  defaultCampaignId: null,
  availableCountryIds: undefined,
  onClose: function onClose() {}
};
var _default = CreateGiftModule;
exports.default = _default;